import { calculateAgeInYears, getAgeRange } from "@src/utils/date-utils";

export type AgeModalScenario =
  | "age_range_mismatch"
  | "age_range_reset_confirmation"
  | "in_person_visit";

type AgeModalGuardOptions = {
  selectedAgeRange?: string;
};

type AgeModalEvaluation = {
  scenario: AgeModalScenario | null;
  patientAge: number;
  patientAgeRange: string | null;
};

/**
 * Evaluates whether the patient's DOB maps to the selected age range.
 */
export const evaluateAgeModalScenario = (
  dobValue: Date | string,
  { selectedAgeRange }: AgeModalGuardOptions,
): AgeModalEvaluation => {
  const dob = dobValue instanceof Date ? dobValue.toISOString() : dobValue;
  const patientAge = calculateAgeInYears(dob);
  const patientAgeRange = getAgeRange(patientAge);

  return {
    scenario:
      selectedAgeRange && patientAgeRange && selectedAgeRange !== patientAgeRange
        ? "age_range_mismatch"
        : null,
    patientAge,
    patientAgeRange,
  };
};

export const willTriggerAgeModal = (
  dobValue: Date,
  { selectedAgeRange }: AgeModalGuardOptions,
): boolean => {
  return evaluateAgeModalScenario(dobValue, { selectedAgeRange }).scenario === "age_range_mismatch";
};
